import { render, staticRenderFns } from "./list-keywords-v2.component.html?vue&type=template&id=3fb79b43&scoped=true&external"
import script from "./list-keywords-v2.component.vue?vue&type=script&lang=ts"
export * from "./list-keywords-v2.component.vue?vue&type=script&lang=ts"
import style0 from "./list-keywords-v2.component.css?vue&type=style&index=0&id=3fb79b43&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb79b43",
  null
  
)

export default component.exports